import { render } from "./video-modal.vue?vue&type=template&id=a2ea6178"
import script from "./video-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./video-modal.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a2ea6178"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2ea6178', script)) {
    api.reload('a2ea6178', script)
  }
  
  module.hot.accept("./video-modal.vue?vue&type=template&id=a2ea6178", () => {
    api.rerender('a2ea6178', render)
  })

}

script.__file = "resources/ts/components/elements/video-modal.vue"

export default script